import injectSheet from 'react-jss'
import SSRTag from './SSRTag'
import styles from './SSRTag.styles'

export default injectSheet(styles)(SSRTag)
